import PropTypes from 'prop-types';
import { Box, Typography, Card } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { Iconify } from 'src/components';
import { settingsCardStyle } from 'src/styles/SettingsMenuStyle';

export default function SettingsSection({ id, icon, title, description, iconColor, badge, children }) {
  return (
    <Card id={id} sx={{ ...settingsCardStyle, p: 0, overflow: 'hidden' }}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1.5,
          px: 2.5,
          py: 1.75,
          bgcolor: alpha(iconColor, 0.04),
          borderBottom: `1px solid ${alpha(iconColor, 0.08)}`,
        }}
      >
        {icon && (
          <Box
            sx={{
              width: 30,
              height: 30,
              borderRadius: '8px',
              bgcolor: alpha(iconColor, 0.1),
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexShrink: 0,
            }}
          >
            <Iconify icon={icon} width={16} height={16} sx={{ color: iconColor }} />
          </Box>
        )}
        <Box flex={1} minWidth={0}>
          <Box display="flex" alignItems="center" gap={1}>
            <Typography fontSize={14} fontWeight={700} color="#1e293b">
              {title}
            </Typography>
            {badge}
          </Box>
          {description && (
            <Typography fontSize={12} color="#94a3b8" noWrap>
              {description}
            </Typography>
          )}
        </Box>
      </Box>
      <Box p={2.5}>{children}</Box>
    </Card>
  );
}

SettingsSection.propTypes = {
  id: PropTypes.string.isRequired,
  icon: PropTypes.string,
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  iconColor: PropTypes.string,
  badge: PropTypes.element,
  children: PropTypes.node.isRequired,
};

SettingsSection.defaultProps = {
  icon: '',
  description: '',
  iconColor: '#64748b',
  badge: null,
};
